import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaLock, FaUserAlt, FaPhoneAlt, FaAt } from "react-icons/fa";

import { Page, Input } from "ui/components";

import { Auth } from "services/action";

import logo from "../../../assets/ic_launcher.png";
import { Button } from "react-bootstrap";

const UpdateScreen = () => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const StateAuth = useSelector((state) => state?.Auth);
  const StateForm = useSelector((state) => state.Form);

  const [name, setName] = React.useState(StateAuth?.session?.name);
  const [username, setUsername] = React.useState(StateAuth?.session?.username);
  const [phone, setPhone] = React.useState(StateAuth?.session?.phone);
  const [password, setPassword] = React.useState("");
  const [confirm, setConfirm] = React.useState("");

  const handleSubmit = async () => {
    const payload = {
      username: username,
      name: name,
      phone: phone,
    };

    if (password) {
      payload.password = password;
      payload.confirm_password = confirm;
    }

    const res = await Dispatch(Auth.$update(payload));

    if (res?.message === "success") {
      // if (phone !== StateAuth?.session?.phone) {
      //   $send();
      // } else {
        Dispatch(Auth.$fetchProfile());
        History.goBack();
      // }
    }
  };

  // const $send = async (e) => {
  //   const payload = {
  //     username: username,
  //     phone: phone,
  //   };
  //   const req = await Dispatch(OTP.$send(payload));

  //   if (req?.message === "success") {
  //     History.replace({
  //       pathname: "/verify",
  //       state: {
  //         username: username,
  //         phone: phone,
  //         phone_otp: req?.data?.replace("62", "0"),
  //       },
  //     });
  //   }
  // };

  React.useEffect(() => {
    Dispatch(Auth.$fetchProfile());
  }, []);

  return (
    <Page title={`Perbaharui Profil`} backTo={() => History.goBack()}>
      <div className="p-2">
        <div className="pb-3 mb-2">
          <div className="text-center pe-0">
            <img
              src={logo}
              className="rounded-circle border border-2 border-white"
              alt=""
              style={{ height: 80, width: 80 }}
            />
          </div>
        </div>

        <div>
          <div className="hr-text hr-text-center text-primary mb-3 mt-md-3 mt-3">
            Informasi
          </div>
          <div className="form-group">
            <Input
              icon={<FaUserAlt />}
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              placeholder="masukkan nama lengkap anda"
              error={StateForm?.errors?.name}
              lg
            />
          </div>
          <div className="form-group">
            <Input
              icon={<FaPhoneAlt />}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              type="number"
              placeholder="masukkan nomor handphone anda"
              error={StateForm?.errors?.phone}
              lg
            />
          </div>
          <div className="form-group">
            <Input
              icon={<FaAt />}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              type="text"
              placeholder="masukkan username anda"
              error={StateForm?.errors?.username}
              disabled
              lg
            />
          </div>

          <div className="hr-text hr-text-center text-primary mb-3 mt-4">
            Ganti Password
          </div>
          <div className="form-group">
            <Input
              icon={<FaLock />}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="masukkan kata sandi baru"
              error={StateForm?.errors?.password}
              lg
            />
          </div>
          <div className="form-group">
            <Input
              icon={<FaLock />}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              type="password"
              placeholder="ulangi kata sandi baru"
              error={StateForm?.errors?.confirm_password}
              lg
            />
          </div>

          <Button
            type="button"
            variant="primary"
            className="w-100 mt-2 p-2 fs-7"
            disabled={StateForm?.loading}
            onClick={handleSubmit}
          >
            {!StateForm?.loading ? (
              "Simpan Perubahan"
            ) : (
              <div className="spinner-border" role="status"></div>
            )}
          </Button>
        </div>
      </div>
    </Page>
  );
};

export default UpdateScreen;
